module.exports = __webpack_public_path__ + "media/home-coffee.994437f2.mp4";